import { useEffect } from 'react';
import { useChatStore } from './useChatStore';

const POLL_MS = 3_000;
const MAX_POLLS = 60; // 3 Minuten

export function useChatSync(
  getAccessToken: () => Promise<string | undefined>,
  enabled: boolean,
) {
  const sessionId = useChatStore((state) => state.sessionId);
  const isPending = useChatStore((state) => state.isPending);
  const syncSession = useChatStore((state) => state.syncSession);

  useEffect(() => {
    if (!enabled) {
      return;
    }
    void syncSession({ getAccessToken });
    const onPageShow = (event: PageTransitionEvent) => {
      if (event.persisted) {
        void syncSession({ getAccessToken });
      }
    };
    window.addEventListener('pageshow', onPageShow);
    return () => window.removeEventListener('pageshow', onPageShow);
  }, [enabled, getAccessToken, syncSession]);

  useEffect(() => {
    if (!enabled || !isPending || !sessionId) {
      return;
    }
    let stopped = false;
    let polls = 0;
    let timer: ReturnType<typeof setTimeout> | undefined;

    const poll = async () => {
      await syncSession({ getAccessToken });
      polls += 1;
      if (!stopped && polls < MAX_POLLS) {
        timer = setTimeout(poll, POLL_MS);
      }
    };

    timer = setTimeout(poll, POLL_MS);
    return () => {
      stopped = true;
      clearTimeout(timer);
    };
  }, [enabled, isPending, sessionId, getAccessToken, syncSession]);
}
